module.exports = __webpack_public_path__ + "static/img/03.1f6d1807.png";